import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

const HAFHActivitiesList = ({ t, role, hostelCode }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();

  const [activities, setActivities] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("ALL");

  const categories = [
    "INDOOR",
    "OUTDOOR",
    "OFFSITE",
    "SPORTS",
    "WELLNESS",
    "CULTURAL",
    "ACADEMIC",
    "SOCIAL",
    "OTHER",
  ];

  const statusFilters = ["SCHEDULED", "ONGOING", "COMPLETED", "CANCELLED"];

  const fetchActivities = async () => {
    try {
      const res = await fetchData({
        url: "/hafh/operations/activities/all",
        method: "post",
        data: { hostelCode },
        headers: {
          Authorization: authState.token,
        },
      });

      if (res?.status) {
        setActivities(res.records || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (hostelCode) fetchActivities();
  }, [hostelCode]);

  const filtered =
    selectedFilter === "ALL"
      ? activities
      : activities.filter(
          (a) =>
            a.activityCategory === selectedFilter ||
            a.activityStatus === selectedFilter
        );

  return (
    <div className="bg-gray-900 p-5 rounded-xl text-white space-y-4">

      {/* HEADER */}
      <h2 className="text-cyan-300 text-lg font-bold">
        🎯 Hostel Activities
      </h2>

      {/* FILTERS */}
      <div className="grid grid-cols-3 lg:grid-cols-7 gap-1">

        <button
          onClick={() => setSelectedFilter("ALL")}
          className={`px-1 py-2 rounded-md text-xs ${
            selectedFilter === "ALL" ? "bg-teal-600" : "bg-gray-700"
          }`}
        >
          ALL
        </button>

        {[...categories, ...statusFilters].map((f) => (
          <button
            key={f}
            onClick={() => setSelectedFilter(f)}
            className={`px-1 py-2 rounded-md text-xs ${
              selectedFilter === f ? "bg-teal-600" : "bg-gray-700"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {/* LIST */}
      <div className="space-y-3 mt-4">

        {filtered.length === 0 ? (
          <div className="text-gray-400 text-sm">
            No activities found
          </div>
        ) : (
          filtered.map((a) => (
            <div
              key={a._id}
              className="bg-gray-800 p-4 rounded-xl border border-gray-700 space-y-2"
            >

              {/* TITLE */}
              <div className="flex justify-between">
                <div className="text-cyan-300 font-semibold">
                  {a.activityName}
                </div>
                <div className="text-xs text-yellow-300">
                  {a.activityCategory}
                </div>
              </div>

              {/* DESCRIPTION */}
              <div className="text-sm text-gray-300">
                {a.activityDescription || "No description"}
              </div>

              {/* TIME */}
              <div className="text-xs text-gray-400">
                📅 {new Date(a.activityDate).toLocaleDateString()}
                {a.startTime && ` | ⏰ ${a.startTime} - ${a.endTime}`}
              </div>

              {/* STATUS */}
              <div className="text-xs">
                Status:{" "}
                <span className="text-teal-300">
                  {a.activityStatus}
                </span>
              </div>

              {/* MODE */}
              <div className="text-xs text-gray-300">
                Mode: {a.activityMode} | Venue: {a.venueName || "N/A"}
              </div>

              {/* PARTICIPATION */}
              <div className="text-xs text-gray-400">
                Max Participants: {a.maxParticipants || "Unlimited"}
              </div>

              {/* TAGS */}
              {a.tags?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                  {a.tags.map((tag, i) => (
                    <span
                      key={i}
                      className="text-xs bg-gray-700 px-2 py-1 rounded"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              )}

              {/* FLAGS */}
              {a.isCompulsory && (
                <div className="text-red-400 text-xs">
                  🔴 Compulsory Activity
                </div>
              )}

              {/* ACTIONS */}
              <div className="flex gap-2 mt-2">

                <button className="px-3 py-1 bg-blue-600 text-xs rounded">
                  View
                </button>

                <button className="px-3 py-1 bg-green-600 text-xs rounded">
                  Join
                </button>

                <button className="px-3 py-1 bg-purple-600 text-xs rounded">
                  Share
                </button>

              </div>

            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HAFHActivitiesList;